import React, { Component } from 'react';
import CVPlanetCardEntry from './CVPlanetCardEntry';

export default class CVPlanetCard extends Component {

	constructor(props) {
		super(props);

		this.state = {
			entries: this.props.entries,
			currentlyShowingEntryDescription: null
		};

		this.minimumOffsetY = -30;
		this.maximumOffsetY = 30;

		this.handlePlanetCardEntryClick = this.handlePlanetCardEntryClick.bind(this);
	}

	calculateEntryOffset(index, rowLength, childLength) {
		let multiplication = index > childLength / 2 ? -1 : 1;
		return (((((Math.abs(this.minimumOffsetY) + this.maximumOffsetY) / rowLength) / 2) * (index + 1)) + this.minimumOffsetY) * multiplication;
	}

	handlePlanetCardEntryClick(entryId) {
		if(this.state.currentlyShowingEntryDescription === entryId)
		{
			this.setState({
				...this.state,
				currentlyShowingEntryDescription: null
			});
		}
		else
		{
			this.setState({
				...this.state,
				currentlyShowingEntryDescription: entryId
			});
		}
	}

	calculateEntryRows(entries) {
		return entries.length % 2 === 0 ? entries.length / 2 : Math.ceil(entries.length / 2);
	}

	renderDescription(before) {
		let description = '';

		if(this.state.currentlyShowingEntryDescription !== null && typeof this.state.entries[this.state.currentlyShowingEntryDescription] !== "undefined" && typeof this.state.entries[this.state.currentlyShowingEntryDescription].description !== "undefined")
		{
			let bubbleClass = "speach-bubble bubble-full " + (this.props.left === false ? "bubble-align-right" : "bubble-align-left");
			description = (
				<div className={bubbleClass}>
					<div className="speach-bubble-content">
						{this.state.entries[this.state.currentlyShowingEntryDescription].description}
					</div>
				</div>
			);
		}

		if((before === true && this.props.left === false) || (before === false && this.props.left === true))
		{
			return (
				<div className="layout-cs-planet-description">{description}</div>
			);
		}
		else
		{
			return '';
		}
	}

	renderPlanetBackdrop() {
		if(typeof this.props.icon === "undefined")
		{
			return "";
		}

		let iconUrl = `/gfx/${this.props.icon}`;

		return <img src={iconUrl} className="layout-cs-planet-backdrop" alt="Backdrop" />;
	}

	render() {
		let planetImage = `/gfx/planets/${this.props.planet}`;
		let cardClass = `layout-cs-card`;
		if(this.props.left === true)
		{
			cardClass += ` card-right`;
		}

		let entryRows = this.calculateEntryRows(this.state.entries);

		return (
			<div className={cardClass} key={this.props.index}>
				<div className="layout-cs-planet-card">
					<div className="layout-cs-planet-container">
						{this.renderDescription(true)}
						<div className="layout-cs-planet">
							<img src={planetImage} className="layout-cs-planet-image" alt="Planet" />
							{this.renderPlanetBackdrop()}
							<div className="layout-cs-planet-items" data-children={this.state.entries.length}>
								{this.state.entries.map((entry, index) => {
									let offsetY = this.calculateEntryOffset(index, entryRows, this.state.entries.length);
									return (
										<CVPlanetCardEntry 
											title={entry.title} 
											icon={entry.icon} 
											key={index}
											id={index}
											tooltipId={entry.id} 
											offsetY={offsetY} 
											showExplanation={this.props.explanation} 
											onClick={this.handlePlanetCardEntryClick} />
									)
								})}
							</div>
						</div>
						{this.renderDescription(false)}
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/CVPlanetCard.js